import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const Forgetpassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [otpVerified, setOtpVerified] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordResetTriggered, setPasswordResetTriggered] = useState(false);
  const [showResendLink, setShowResendLink] = useState(false);
  const [resendCountdown, setResendCountdown] = useState(60);

  useEffect(() => {
    // If both OTPs are verified and password reset is not triggered, reset the password
    if (otpVerified && !passwordResetTriggered) {
      handleResetPassword();
      setPasswordResetTriggered(true); // Set the state to indicate that password reset is triggered
    }
  }, [otpVerified, passwordResetTriggered]);

  useEffect(() => {
    let countdownTimer;
    if (showResendLink && resendCountdown > 0) {
      countdownTimer = setInterval(() => {
        setResendCountdown((prevCount) => prevCount - 1);
      }, 1000);
    } else if (resendCountdown === 0) {
      setShowResendLink(true);
    }

    return () => {
      clearInterval(countdownTimer);
    };
  }, [showResendLink, resendCountdown]);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSendOTP = async () => {
    try {
      const accountCheckResponse = await axios.post('https://pgdost.onrender.com/auth/checkaccount', { email });

      if (accountCheckResponse.data === true) {
        const otpResponse = await axios.post('https://pgdost.onrender.com/auth/generateotp', { email });
        if (otpResponse.data === true) {
            toast.success('OTP has been sent successfully. Proceed to the next step.');
          setOtpSent(true);
          setShowResendLink(true); // Hide the "Resend OTP" link after sending the initial OTP
          setResendCountdown(60); // Reset the countdown
        } else {
            toast.error('An error occurred while sending OTP. Please try again.');
        }
      } else {
        toast.error('No account found with the provided email. Please sign up.');
      }
    } catch (error) {
      console.error('Error sending OTP:', error);
      toast.error('An error occurred while sending OTP. Please try again.');
    }
  };

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  const handleVerifyOTP = async () => {
    try {

        console.log('Verify OTP Request Data:', { email, otp });
     const otpVerificationResponse = await axios.post('https://pgdost.onrender.com/auth/verifyotp', {
        email,
        otp,
      });
      console.log('Verify OTP Response Data:', otpVerificationResponse.data);
      
      if (otpVerificationResponse.data === true) {
        setOtpVerified(true);
        toast.success('OTP verified successfully. You can now reset your password.');
      } 
      else  {
        toast.error('OTP verification failed. Please check the entered OTP.');
        setOtpVerified(false);
      }
    } catch (error) {
      console.error('Error verifying OTP:', error);
      toast.error('sdfsdfsd.');
    }
  };
  
  
  

  const handleNewPasswordChange = (e) => {
    setNewPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleResetPassword = async () => {
    try {
      // Check if newPassword and confirmPassword are not null or empty
      if(newPassword !== confirmPassword){
        toast.error('Password and Confirm Password must match.');
      }
       else if (newPassword && confirmPassword && newPassword === confirmPassword && otpVerified) {
        // Reset the password after OTP is verified
        const resetPasswordResponse = await axios.post('https://pgdost.onrender.com/auth/resetpassword', {
          email,
          newPassword,
        });

        if (resetPasswordResponse.data === true) {
          toast.success('Password reset successfully.');
          setTimeout(() => {
            navigate('/login');
          }, 2000);
        } else {
          toast.error('Password reset failed. Please try again.');
        }
      } 

    } catch (error) {
      console.error('Error resetting password:', error);
      toast.error('Password reset failed. Please try again.');
    }
  };

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-2xl font-semibold mb-4">Forgot Password</h2>
          <p className="text-gray-600 mb-4">Enter your email address to reset your password.</p>
          <div className="mb-4">
            <input
              type="email"
              placeholder="Email address"
              value={email}
              onChange={handleEmailChange}
              disabled={otpVerified}
              className="w-full border p-2 rounded focus:outline-none focus:shadow-outline"
            />
          </div>
          {!otpSent ? (
            <button
              className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              onClick={handleSendOTP}
            >
              Send OTP
            </button>
          ) : otpVerified ? (
            <div>
              <p>OTP Verified. Proceed to reset your password.</p>
              <div className="mb-4">
                <input
                  type="password"
                  placeholder="New Password"
                  value={newPassword}
                  onChange={handleNewPasswordChange}
                  className="w-full border p-2 rounded focus:outline-none focus:shadow-outline"
                />
              </div>
              <div className="mb-4">
                <input
                  type="password"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={handleConfirmPasswordChange}
                  className="w-full border p-2 rounded focus:outline-none focus:shadow-outline"
                />
              </div>
              <button
                className="w-full bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                onClick={handleResetPassword}
              >
                Reset Password
              </button>
            </div>
          ) : (
            <div>
              <div className="mb-4">
                <input
                  className="w-full border p-2 rounded focus:outline-none focus:shadow-outline"
                  type="text"
                  placeholder="Enter 4-digit OTP"
                  value={otp}
                  onChange={handleOtpChange}
                />
              </div>
              <button
                className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                onClick={handleVerifyOTP}
              >
                Validate
              </button>
              {showResendLink && resendCountdown === 0 && (
                <p
                  className="text-blue-500 cursor-pointer"
                  onClick={handleSendOTP}
                >
                  Resend OTP
                </p>
              )}
              {showResendLink && resendCountdown > 0 && (
                <p className="text-gray-500">
                  Resend OTP ({resendCountdown}s)
                </p>
              )}
            </div>
          )}
          <p className="mt-4">
            Already have an account?{' '}
            <a
              href="#"
              onClick={() => navigate('/login')}
              className="text-blue-500 hover:underline"
            >
              Login
            </a>
          </p>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick rtl pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
};
